<template>
  <div class="popup-settle-debt">
    <b-modal v-model="show" hide-footer :titleHtml="modalTitle" size="lg">
      <b-row>
        <b-col md="6">
          <b-form-group v-if="employee">
            <label>Mã nhân viên:</label>
            <b-form-input
              class="input-style"
              size="sm"
              :value="employee.employeeCode || '—'"
              :disabled="true"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group v-if="employee">
            <label>Tên nhân viên:</label>
            <b-form-input
              class="input-style"
              size="sm"
              :value="employee.employeeName"
              :disabled="true"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group v-if="employee">
            <label>Kỳ thu:</label>
            <b-form-input
              class="input-style"
              size="sm"
              :value="cycle"
              :disabled="true"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="8">
          <b-form-group v-if="employee" class="required-control">
            <label>Số tiền thu:</label>
            <b-row no-gutters>
              <b-col cols="5" class="pr-2">
                <b-form-select
                  class="select-style"
                  v-model="paymentMethod"
                  :options="paymentMethods"
                  size="sm"
                  value-field="value"
                  text-field="text"
                ></b-form-select>
              </b-col>
              <b-col cols="7">
                <b-form-input
                  class="input-style text-right cd-amount-input"
                  size="sm"
                  :value="formatAmount(employee.pendingAmount)"
                  :disabled="true"
                ></b-form-input>
              </b-col>
            </b-row>
            <small v-if="methodError" class="text-danger">{{
              methodError
            }}</small>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group v-if="paymentMethod === 'BANK_TRANSFER'">
        <label>
          Mã tham chiếu
          <span class="text-muted small"
            >(số GD chuyển khoản — bỏ trống nếu chưa có)</span
          >
        </label>
        <b-form-input
          class="input-style"
          size="sm"
          type="text"
          v-model="paymentReference"
          placeholder="VD: FT123456789 / số giao dịch sao kê NH"
        ></b-form-input>
      </b-form-group>

      <b-form-group>
        <label class="d-block">
          <i class="fas fa-list-ul mr-1 cd-label-icon"></i>
          Chi tiết hợp đồng + voucher sẽ thu
          <span class="text-muted small">(toàn bộ chuyển sang SETTLED)</span>
        </label>
        <b-table
          :items="debtRows"
          :fields="debtFields"
          :small="true"
          :busy="loadingDebts"
          bordered
          hover
          show-empty
          empty-text="Không có dữ liệu"
          class="cd-debt-table mb-0"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner small class="align-middle mr-2"></b-spinner>
              <strong>Đang tải...</strong>
            </div>
          </template>
          <template #cell(amount)="data">
            {{ formatAmount(data.item.amount) }}
          </template>
          <template #cell(createdAt)="data">
            {{ formatDate(data.item.createdAt) }}
          </template>
        </b-table>
      </b-form-group>

      <b-form-group label="Diễn giải:">
        <b-form-textarea
          size="sm"
          class="input-style"
          v-model="paymentNote"
          :placeholder="defaultNotePlaceholder"
          :rows="2"
          :max-rows="5"
          maxlength="500"
        ></b-form-textarea>
        <small class="text-muted">
          Để trống → BE tự sinh diễn giải gồm list HĐ + voucher.
        </small>
      </b-form-group>

      <div class="text-right">
        <b-button
          style="margin-right: 10px; font-weight: 600; width: 80px"
          variant="secondary"
          size="sm"
          :disabled="loading"
          @click="close"
        >
          Hủy
        </b-button>
        <b-button
          style="font-weight: 600; width: 100px"
          variant="primary"
          size="sm"
          :disabled="loading || loadingDebts || !debtRows.length"
          @click="submit"
        >
          <b-spinner v-if="loading" small class="mr-1" />
          Xác nhận thu
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { CommissionDebtService } from '@/core/services/commission-debt.service';

export default {
  name: 'SettleDebtDialog',
  props: {
    value: Boolean,
    employee: { type: Object, default: null },
    cycle: { type: String, default: '' },
  },
  data() {
    return {
      paymentMethod: 'BANK_TRANSFER',
      paymentMethods: [
        { value: 'BANK_TRANSFER', text: 'Chuyển khoản' },
        { value: 'CASH', text: 'Tiền mặt' },
      ],
      paymentReference: '',
      paymentNote: '',
      methodError: '',
      loading: false,
      debtRows: [],
      loadingDebts: false,
      debtFields: [
        {
          key: 'contractNumber',
          label: 'Số HĐ',
          thClass: 'text-center',
        },
        {
          key: 'voucherCode',
          label: 'Voucher',
          thClass: 'text-center',
        },
        {
          key: 'amount',
          label: 'Số tiền',
          thClass: 'text-center',
          tdClass: 'text-right',
          thStyle: { width: '20%' },
        },
        {
          key: 'createdAt',
          label: 'Ngày áp',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '17%' },
        },
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
        if (!v) this.resetForm();
      },
    },
    modalTitle() {
      return `<div><span class='d-block' style='font-size: 1.1rem'>Lập phiếu thu công nợ commission: <a class='text-primary'>#${
        this.employee?.employeeCode || '—'
      } ${this.employee?.employeeName || ''}</a></span></div>`;
    },
    defaultNotePlaceholder() {
      if (!this.debtRows.length) return 'Thêm ghi chú (tuỳ chọn)';
      const head = this.debtRows
        .slice(0, 2)
        .map((d) => `${d.contractNumber} (${d.voucherCode})`)
        .join(', ');
      const more =
        this.debtRows.length > 2
          ? ` và ${this.debtRows.length - 2} HĐ khác`
          : '';
      return `Mặc định: Thu CK NV ${this.cycle} — ${head}${more}`;
    },
  },
  watch: {
    value(v) {
      if (v && this.employee) this.fetchDebts();
    },
  },
  methods: {
    formatAmount(n) {
      return Number(n || 0).toLocaleString('vi-VN') + ' đ';
    },
    formatDate(s) {
      if (!s) return '';
      const d = new Date(s);
      return d.toLocaleDateString('vi-VN');
    },
    resetForm() {
      this.paymentMethod = 'BANK_TRANSFER';
      this.paymentReference = '';
      this.paymentNote = '';
      this.methodError = '';
      this.debtRows = [];
    },
    close() {
      this.show = false;
    },
    async fetchDebts() {
      if (!this.employee?.employeeId) return;
      this.loadingDebts = true;
      try {
        const res = await CommissionDebtService.list({
          employeeId: this.employee.employeeId,
          cycle: this.cycle,
          status: 'PENDING',
          page: 1,
          limit: 200,
        });
        const payload = res?.data?.data?.data || {};
        this.debtRows = payload.items || [];
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[SettleDebtDialog] fetchDebts error:', e);
        this.debtRows = [];
      } finally {
        this.loadingDebts = false;
      }
    },
    async submit() {
      if (!this.paymentMethod) {
        this.methodError = 'Bắt buộc chọn hình thức thanh toán';
        return;
      }
      if (!this.employee?.employeeId) {
        this.methodError = 'Thiếu employeeId';
        return;
      }
      this.methodError = '';
      this.loading = true;
      try {
        const res = await CommissionDebtService.settle({
          employeeId: this.employee.employeeId,
          cycle: this.cycle,
          paymentMethod: this.paymentMethod,
          paymentReference:
            this.paymentMethod === 'BANK_TRANSFER'
              ? this.paymentReference || undefined
              : undefined,
          paymentNote: this.paymentNote || undefined,
        });
        this.$emit('settled', res?.data?.data?.data || res?.data?.data);
        this.$bvToast?.toast?.('Đã thu công nợ thành công', {
          variant: 'success',
          title: 'Thành công',
          autoHideDelay: 4000,
        });
        this.show = false;
      } catch (e) {
        const msg =
          e?.response?.data?.message || e?.message || 'Lỗi không xác định';
        this.methodError = msg;
        // eslint-disable-next-line no-console
        console.error('[SettleDebtDialog] settle error:', e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-settle-debt {
  .input-style {
    &:disabled {
      background-color: #f8f9fa;
      color: #495057;
    }
  }
  .cd-amount-input {
    color: #f59e0b;
    font-weight: 700;
  }
  .cd-debt-table {
    background: transparent;
    font-size: 12.5px;
  }
  .cd-label-icon {
    color: inherit !important;
    font-size: 11px;
  }
  label {
    font-weight: 600;
    color: #3f4254;
    margin-bottom: 4px;
  }
}
</style>
